<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-12 col-md-10">
      <div class="row">
        <div class="col-6 col-md-4 col-lg-3" *ngFor="let item of [].constructor(40);">
          <div class="loader-placeholder__item">
            <img src="/assets/img/skeleton.svg" alt="Placeholder" *ngIf="dataType === 'professions-preview'">
            <img src="/assets/img/skeleton-job.svg" alt="Placeholder" *ngIf="dataType === 'job-preview'">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


